import { useState, useEffect, useCallback } from 'react';

const TOAST_VISIBLE_MS = 5000;
/** Delays from page load: 48s, 1:50, 5min, 8min */
const SCHEDULE_MS = [48_000, 110_000, 300_000, 480_000];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const MSGS_EARLY = [
  'Cineva tocmai a rezervat un bilet Early Bird.',
  'Un loc la oferta Discount tocmai a fost ocupat.',
  'Tocmai s-a achiziționat un bilet la prețul Early Bird.',
];

const MSGS_VIP = [
  'Cineva și-a asigurat acum un loc VIP.',
  'Un bilet VIP tocmai a fost achiziționat.',
  'Tocmai s-a rezervat un loc în zona VIP.',
];

const MSGS_ULTRA = [
  'Un bilet Ultra VIP tocmai a fost rezervat.',
  'Cineva și-a achiziționat un loc Ultra VIP.',
  'Tocmai s-a ocupat un loc în zona Ultra VIP.',
];

/**
 * Social proof: toast-uri discrete + offset local pentru locuri afișate (nu modifică API).
 */
export function useSalesSocialProof() {
  const [earlyBirdOffset, setEarlyBirdOffset] = useState(0);
  const [vipOffset, setVipOffset] = useState(0);
  const [ultraVipOffset, setUltraVipOffset] = useState(0);
  const [toastText, setToastText] = useState(null);

  const hideToast = useCallback(() => {
    setToastText(null);
  }, []);

  useEffect(() => {
    const timers = [];
    const hideTimers = [];

    const showToast = (text) => {
      setToastText(text);
      hideTimers.push(setTimeout(() => setToastText(null), TOAST_VISIBLE_MS));
    };

    const runAt = (delayMs, fn) => {
      timers.push(setTimeout(fn, delayMs));
    };

    runAt(SCHEDULE_MS[0], () => {
      setEarlyBirdOffset((o) => o + 1);
      showToast(pick(MSGS_EARLY));
    });

    runAt(SCHEDULE_MS[1], () => {
      if (Math.random() < 0.5) {
        setVipOffset((o) => o + 1);
        showToast(pick(MSGS_VIP));
      } else {
        setUltraVipOffset((o) => o + 1);
        showToast(pick(MSGS_ULTRA));
      }
    });

    runAt(SCHEDULE_MS[2], () => {
      setEarlyBirdOffset((o) => o + 1);
      showToast(pick(MSGS_EARLY));
    });

    runAt(SCHEDULE_MS[3], () => {
      if (Math.random() < 0.5) {
        setVipOffset((o) => o + 1);
        showToast(pick(MSGS_VIP));
      } else {
        setUltraVipOffset((o) => o + 1);
        showToast(pick(MSGS_ULTRA));
      }
    });

    return () => {
      timers.forEach(clearTimeout);
      hideTimers.forEach(clearTimeout);
    };
  }, []);

  return {
    earlyBirdOffset,
    vipOffset,
    ultraVipOffset,
    toastText,
    hideToast,
  };
}
